function enableDictionaryFields(rootElement) {

    const dictionaryFields = $(rootElement).find('.dictionary-field').toArray();

    for (let dictionaryField of dictionaryFields) {
        const loadingSpinner = $(dictionaryField).find('.lds-spinner');
        const searchUrl = $(dictionaryField).data('searchUrl');
        const searchInput = $(dictionaryField).find('.search-input');
        const availableInput = $(dictionaryField).find('.available-input');
        const selectedInput = $(dictionaryField).find('.selected-input');
        const availableListContainer = $(dictionaryField).find('.results-list');
        const selectedListContainer = $(dictionaryField).find('.selected-list');

        console.log(selectedListContainer.toArray());

        let activeRequest = null;

        searchInput.on('paste keyup', async function (ev) {

            if (!((46 <= ev.which && ev.which <= 90) ||
                ev.which === 8 ||
                (96 <= ev.which && ev.which <= 105) ||
                ev.which === 188 ||
                ev.which === 190)) {
                return;
            }

            ev.preventDefault();

            loadingSpinner.show();

            availableListContainer.empty();
            selectedListContainer.empty();

            if (activeRequest != null) {
                activeRequest.abort();
            }

            const searchTerm = $(this).val();

            if(searchTerm === '') {
                availableListContainer.empty();
                selectedListContainer.empty();
                availableInput.val('');
                selectedInput.val('');
                updateDictionaryCounts(dictionaryField, 0, 0);
                loadingSpinner.hide();
                return;
            }

            let results = {items: []};
            try {
                activeRequest = $.get(`${searchUrl}?term=${searchTerm}`);
                results = await activeRequest;
            } catch (e) {
                console.log('Request aborted or errored');
                return;
            }

            availableListContainer.empty();
            selectedListContainer.empty();

            const availableResults = results.items.map(item => {
                return item.id;
            });

            availableInput.val(JSON.stringify(availableResults));
            selectedInput.val(JSON.stringify([]));

            let selectedResults = [];

            const availableCount = results.items.length;
            updateDictionaryCounts(dictionaryField, availableCount, selectedResults.length);

            for (let result of results.items) {
                availableListContainer.append(`<div data-value="${result.id}" class="name-option name-option-hover">${result.text}</div>`);
            }

            availableListContainer.find('.name-option').on('click', function (event) {
                event.stopPropagation();

                const value = $(this).data('value');
                const text = $(this).text();

                selectedResults.push(value);
                selectedInput.val(JSON.stringify(selectedResults));
                updateDictionaryCounts(dictionaryField, availableCount, selectedResults.length);

                $(this).hide();

                $(`<div data-value="${value}" class="name-option name-option-hover">${text}</div>`)
                    .on('click', function (event1) {
                        event1.stopPropagation();

                        availableListContainer.find(`.name-option[data-value="${value}"]`).show();
                        $(this).remove();

                        selectedResults = selectedResults.filter(selectedItem => selectedItem !== value);
                        selectedInput.val(JSON.stringify(selectedResults));

                        updateDictionaryCounts(dictionaryField, availableCount, selectedResults.length);
                    })
                    .appendTo(selectedListContainer);

            });

            loadingSpinner.hide();
        })
    }
}

function updateDictionaryCounts(dictionaryField, availableCount, selectedCount){
    const availableCountContainer = $(dictionaryField).find('.results-count');
    const selectedCountContainer = $(dictionaryField).find('.selected-count');

    if(availableCount === 0){
        availableCountContainer.text('');
        selectedCountContainer.text('');
        return;
    }

    availableCountContainer.text(availableCount + (availableCount === 500 ? '+ results found' : ' results found'));

    const selectedText = selectedCount === 0 ? 'all' : selectedCount;
    selectedCountContainer.text('Searching ' + selectedText + (selectedCount === 1 ? ' result' : ' results'));
}